import { render, staticRenderFns } from "./KeyDataTab.vue?vue&type=template&id=086f02a3&"
import script from "./KeyDataTab.vue?vue&type=script&lang=ts&"
export * from "./KeyDataTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports